/**
 * 图快照 —— 纯逻辑。
 *
 * 撤销/重做、复制/粘贴都建立在「把图变成一份可以独立存活的普通数据」上。
 * 这里刻意只做**深拷贝**，不做结构校验 —— 校验是别的模块的事。
 *
 * ⚠️ 用 JSON 而不是 structuredClone：我们的图数据本来就要求是 JSON 安全的
 * （模板要能序列化保存 / 传给 C++），所以 JSON 往返既够用又能顺带**验证**
 * 这份数据确实可序列化。真要存了 Date / Map，这里会立刻暴露出来。
 */

export interface GraphSnapshot {
  nodes: Record<string, unknown>[]
  edges: Record<string, unknown>[]
}

/** 深拷贝一份 JSON 安全的数据 */
export function cloneJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T
}

export function snapshotGraph(
  nodes: readonly unknown[],
  edges: readonly unknown[],
): GraphSnapshot {
  return {
    nodes: cloneJson(nodes) as Record<string, unknown>[],
    edges: cloneJson(edges) as Record<string, unknown>[],
  }
}

/**
 * 两份快照是否等价。
 *
 * 用途：拖拽结束后判断「到底有没有真的动过」——没动就不该占用一步历史。
 */
export function sameSnapshot(a: GraphSnapshot, b: GraphSnapshot): boolean {
  return JSON.stringify(a) === JSON.stringify(b)
}
